import type { ReactNode } from 'react';
import { useAuth } from '@/app/providers';
import { LoadingScreen } from '@/core/ui/components';
import { LoginPage } from '../pages/LoginPage';
import { TenantSelectionPage } from '../pages/TenantSelectionPage';

interface AuthGuardProps {
  children: ReactNode;
}

export function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated, isLoading, requiresTenantSelection, user } = useAuth();

  if (isLoading) {
    return <LoadingScreen message="Authenticating..." />;
  }

  if (!user && !requiresTenantSelection) {
    return <LoginPage />;
  }

  if (requiresTenantSelection) {
    return <TenantSelectionPage />;
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <>{children}</>;
}
